export default {
  headerTop: 'سجّل اهتمامك لنتصل بك',
  headerAldar: 'سجّل الآن',
  headerRegister: 'سجّل الآن',
  bannerTextOne: 'سجّل الآن',
  bannerTextTwo: 'سجّل الآن',
  registerStory: 'سجّل الآن',
  registerButton: 'سجّل الآن',
  welcomeHeading: 'سجّل الآن',
  welcomeContent: 'سجّل الآن',
  tabAmenity: 'سجّل الآن',
  tabSustain: 'سجّل الآن',
  tabLocation: 'سجّل الآن',
  amenityHeading: 'سجّل الآن',
  amenityContent: 'سجّل الآن',
  sustainHeading: 'سجّل الآن',
  sustainContent: 'سجّل الآن',
  locationHeading: 'سجّل الآن',
  locationContent: 'سجّل الآن',
  tabButton: 'سجّل الآن',
  footerLink: 'سجّل الآن',
};
